import { FORM_GROUPS } from "./formSpec";
import { AttachmentChip } from "./ProofUploader";
import { fmtIDR } from "./util";

const fmt = (v, type) => (type === "money" ? fmtIDR(v) : Number(v || 0).toLocaleString("id-ID"));

export function SimpleTotals({ totals }) {
    const items = [
        ["total_sales_idr", "Total Penjualan", "Ready Stock + PO Baru"],
        ["total_payment_idr", "Total Pembayaran Produk", "Ready Stock + DP PO + Pelunasan"],
        ["total_shipping_idr", "Ongkir", "Terpisah dari pembayaran produk"],
        ["total_marketplace_pending_idr", "Saldo Marketplace Tertunda", "Belum termasuk uang masuk"],
    ];
    const pct = totals.followup_completion_pct;
    return (
        <div className="space-y-3" data-testid="simple-totals">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {items.map(([k, label, sub]) => (
                    <div key={k} className="bg-white border border-mist rounded-sm p-3">
                        <div className="text-[10px] uppercase tracking-widest text-neutral-400">{label}</div>
                        <div className="font-serif text-xl mt-1" data-testid={`simple-${k}`}>{fmtIDR(totals[k])}</div>
                        <div className="text-[10px] text-neutral-400 mt-0.5">{sub}</div>
                    </div>
                ))}
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-1 text-xs text-neutral-600" data-testid="simple-followup-summary">
                <span>Follow-up selesai: <b className="text-ink">{totals.followups_done}</b></span>
                <span>Terlewat: <b className={totals.followups_missed ? "text-amber-700" : "text-ink"}>{totals.followups_missed}</b></span>
                <span>Penyelesaian: <b className="text-ink" data-testid="simple-followup-pct">{pct === null || pct === undefined ? "—" : `${pct}%`}</b></span>
                <span>Order: <b className="text-ink">{totals.total_orders}</b></span>
                <span>Closing: <b className="text-ink">{totals.total_closings}</b></span>
            </div>
        </div>
    );
}

export default function SimpleReportView({ figures, handover, totals, attachments }) {
    return (
        <div className="space-y-6" data-testid="simple-report-view">
            <SimpleTotals totals={totals} />
            <div className="grid md:grid-cols-2 gap-4">
                {FORM_GROUPS.map((g) => (
                    <div key={g.title} className="bg-white border border-mist rounded-sm p-4">
                        <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-400 mb-2">{g.title}</div>
                        {g.fields.map(([k, label, type]) => (
                            <div key={k} className="flex justify-between py-1 text-sm border-b border-mist/60 last:border-0">
                                <span className="text-neutral-600">{label}</span>
                                <span className="tabular-nums" data-testid={`view-${k}`}>{fmt(figures[k], type)}</span>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            <div className="bg-white border border-mist rounded-sm p-4 text-sm space-y-1" data-testid="view-handover">
                <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-400 mb-1">Serah terima</div>
                <div className="whitespace-pre-wrap">{handover?.notes || <span className="text-neutral-400">Tidak ada catatan customer tertunda</span>}</div>
                {handover?.pic && <div className="text-xs text-neutral-500">PIC: {handover.pic}</div>}
            </div>
            <div data-testid="view-attachments">
                <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-400 mb-2">Bukti ({attachments.length})</div>
                <div className="flex flex-wrap gap-2">
                    {attachments.map((a) => <AttachmentChip key={a.id} a={a} />)}
                </div>
            </div>
        </div>
    );
}
